import { type FC, useState } from "react";
import type { DialogController } from "../../../../../../utils/hooks/use-dialog";
import type { UUID } from "../../../../../../utils/uuid";
import { PageWithFooterWrapper } from "../../../../../generic/components/page-with-footer-wrapper";
import { PreviewBody } from "./preview-body/preview-body";
import { PreviewFooter } from "./preview-footer";
import { PreviewHeader } from "./preview-header";
import { PreviewSidebar } from "./preview-sidebar/preview-sidebar";

export const PreviewInner: FC<{
  dialog: DialogController<{ isReview: boolean }>;
  momentId: UUID;
  buttons?: {
    sendTest?: React.ReactNode;
    publish?: React.ReactNode;
  };
}> = ({ dialog, momentId, buttons, ...rest }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <>
      <PreviewHeader onClose={dialog.handleClose} />
      <PageWithFooterWrapper>
        <PreviewSidebar open={sidebarOpen} isReview={dialog.data?.isReview ?? false} />
        <PreviewBody momentId={momentId} sendTestButton={buttons?.sendTest} {...rest} />
      </PageWithFooterWrapper>
      <PreviewFooter
        sidebarOpen={sidebarOpen}
        toggleSidebar={() => setSidebarOpen((prev) => !prev)}
        onClose={dialog.handleClose}
        momentId={momentId}
        isReview={dialog.data?.isReview ?? false}
        closePreviewDialog={dialog.handleClose}
        buttons={buttons}
        {...rest}
      />
    </>
  );
};
